// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".translate-list[data-v-5b0c3bdb] {\n  display: flex;\n  flex-direction: column;\n  row-gap: 4px;\n}\n.translate-list .translate-li[data-v-5b0c3bdb] {\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
